import { Component } from '@angular/core';

@Component({
  selector: 'app-alertrndc',
  templateUrl: './alertrndc.component.html',
  styleUrls: ['./alertrndc.component.scss']
})
export class AlertrndcComponent { }
